module.exports = __webpack_public_path__ + "static/media/megha.a72acb16.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/contacts/megha.png
// module id = 743
// module chunks = 0